import React from 'react'
import { YStack } from 'tamagui'

export const YouTubeEmbed = ({
  youtubeEmbedUrl,
}: {
  youtubeEmbedUrl: string
}) => (
  <YStack width="100%" maxWidth="100%">
    <iframe
      src={youtubeEmbedUrl}
      width="853"
      height="480"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
      style={{
        left: 0,
        top: 0,
        width: '100%',
      }}
    />
  </YStack>
)
